<template>
  <div class="page row">
    <app-title
      :page="'Buttons'"
      :prehead="'Nimber Manual'">
      <app-manual-nav slot="content"/>
    </app-title>
    <div class="grid">
      <section>
        <h2>Standard buttons</h2>
        <p>
          <button>Native button</button>
          <a
            href="#"
            class="button">Normal button</a>
          <a
            href="#"
            class="button accent-button">Accent button</a>
          <a
            href="#"
            class="button white-button">White button</a>
          <a
            href="#"
            class="button grey-button">Grey button</a>
          <a
            href="#"
            class="button black-button">Black button</a>
          <a
            href="#"
            class="button light-red-button">Light red button</a>
          <a
            href="#"
            class="button dark-red-button">Dark red button</a>
          <a
            href="#"
            class="button light-blue-button">Light blue button</a>
          <a
            href="#"
            class="button dark-blue-button">Dark blue button</a>
          <a
            href="#"
            class="button yellow-button">Yellow button</a>
          <a
            href="#"
            class="button green-button">Green button</a></p>
      </section>
      <section>
        <h2>Small buttons</h2>
        <p><a
          href="#"
          class="button small-button">Normal button</a>
          <a
            href="#"
            class="button small-button accent-button">Accent button</a>
          <a
            href="#"
            class="button small-button white-button">White button</a>
          <a
            href="#"
            class="button small-button grey-button">Grey button</a>
          <a
            href="#"
            class="button small-button black-button">Black button</a>
          <a
            href="#"
            class="button small-button light-red-button">Light red button</a>
          <a
            href="#"
            class="button small-button dark-red-button">Dark red button</a>
          <a
            href="#"
            class="button small-button light-blue-button">Light blue button</a>
          <a
            href="#"
            class="button small-button dark-blue-button">Dark blue button</a>
          <a
            href="#"
            class="button small-button yellow-button">Yellow button</a>
          <a
            href="#"
            class="button small-button green-button">Green button</a></p>
      </section>
      <section>
        <h2>Large buttons</h2>
        <p><a
          href="#"
          class="button large-button">Normal button</a>
          <a
            href="#"
            class="button large-button accent-button">Accent button</a>
          <a
            href="#"
            class="button large-button white-button">White button</a>
          <a
            href="#"
            class="button large-button grey-button">Grey button</a>
          <a
            href="#"
            class="button large-button black-button">Black button</a>
          <a
            href="#"
            class="button large-button light-red-button">Light red button</a>
          <a
            href="#"
            class="button large-button dark-red-button">Dark red button</a>
          <a
            href="#"
            class="button large-button light-blue-button">Light blue button</a>
          <a
            href="#"
            class="button large-button dark-blue-button">Dark blue button</a>
          <a
            href="#"
            class="button large-button yellow-button">Yellow button</a>
          <a
            href="#"
            class="button large-button green-button">Green button</a></p>
      </section>
      <section>
        <h2>Ghost buttons</h2>
        <p><a
          href="#"
          class="button ghost-button">Normal button</a>
          <a
            href="#"
            class="button ghost-button accent-button">Accent button</a>
          <a
            href="#"
            class="button ghost-button white-button">White button</a>
          <a
            href="#"
            class="button ghost-button grey-button">Grey button</a>
          <a
            href="#"
            class="button ghost-button black-button">Black button</a>
          <a
            href="#"
            class="button ghost-button light-red-button">Light red button</a>
          <a
            href="#"
            class="button ghost-button dark-red-button">Dark red button</a>
          <a
            href="#"
            class="button ghost-button light-blue-button">Light blue button</a>
          <a
            href="#"
            class="button ghost-button dark-blue-button">Dark blue button</a>
          <a
            href="#"
            class="button ghost-button yellow-button">Yellow button</a>
          <a
            href="#"
            class="button ghost-button green-button">Green button</a></p>
      </section>
    </div>
  </div>
</template>

<script>
import Title from '../common/Title'
import ManualNav from './ManualNav'
import Swatch from './components/Swatch'

export default {
  components: {
    appTitle: Title,
    appManualNav: ManualNav,
    appSwatch: Swatch
  }
}
</script>
